import type { GeoInfo } from "./types";

const CACHE_KEY = "rc:geo";

const emptyGeo: GeoInfo = {
  country: null,
  region: null,
  city: null,
  isCanada: false,
  isQuebec: false,
  isUS: false,
};

export async function fetchGeo(): Promise<GeoInfo> {
  if (typeof window === "undefined") return emptyGeo;
  try {
    const cached = sessionStorage.getItem(CACHE_KEY);
    if (cached) return JSON.parse(cached) as GeoInfo;
  } catch {
    /* noop */
  }

  try {
    const res = await fetch("/api/geo", { credentials: "omit" });
    if (!res.ok) return emptyGeo;
    const data = (await res.json()) as GeoInfo;
    try {
      sessionStorage.setItem(CACHE_KEY, JSON.stringify(data));
    } catch {
      /* noop */
    }
    return data;
  } catch {
    return emptyGeo;
  }
}
